import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable operator-linebreak */ /* eslint-disable react/jsx-no-target-blank */ import './index.scss';
import React, { useEffect, useState } from 'react';
import { ArrowUpDownIcon, CalculatorIcon } from '../../components/Icons';
import { useIsMobileState } from '../../hooks/useIsMobileState';
import { reportShow } from '../../utils/reportUtil';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_URL = 'https://www.tencentcloud.com/';
var arrayGenerator = function(length, generator) {
    var array = [];
    var i = 0;
    while(i < length){
        array.push(generator(i));
        i += 1;
    }
    return array;
};
/**
 * 定价产品服务介绍组件
 * @props.style  { backgroundColor: "#fff" }
 * @props.title "产品服务"
 * @props.list [{
          title: "Cloud Virtual Machine",
          logo: "https://main.qcloudimg.com/raw/860a531bada396bb3c0670c615cee34d.svg",
          intro_list: [
            {
              title: "CPU",
              text: "1 水电费水电费是否",
              link: "https://learn.woa.com",
              hasCalculator: true,
            },
          ],
        }]
 */ export default function ProductsService(props) {
    var ref = _slicedToArray(useIsMobileState(), 1), isMobile = ref[0];
    var ref1 = useState(-1), activeItemIndex = ref1[0], setActiveItemIndex = ref1[1];
    var title = props.title, _style = props.style, style = _style === void 0 ? {} : _style, _list = props.list, list = _list === void 0 ? [] : _list, index1 = props.index;
    var rows = Math.ceil(list.length / 5);
    useEffect(function() {
        setActiveItemIndex(isMobile ? -1 : 0);
    }, [
        isMobile
    ]);
    var onClickItem = function(item) {
        var index = list.indexOf(item);
        setActiveItemIndex(index === activeItemIndex ? -1 : index);
    };
    var buildGroup = function(row, group) {
        var showIntro = activeItemIndex > -1 && Math.floor(activeItemIndex / 5) === row;
        var intro = [];
        if (showIntro) {
            intro = list[activeItemIndex].intro_list;
        }
        return(/*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("ul", {
                    className: "pricing-products-group",
                    children: [
                        group.map(function(item1, indx) {
                            var index2 = row * 5 + indx;
                            return [
                                /*#__PURE__*/ _jsxs("li", {
                                    onClick: function() {
                                        return onClickItem(item1);
                                    },
                                    className: "".concat(activeItemIndex === index2 ? 'product-active' : ''),
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            className: "pricing-product-logo",
                                            src: item1.logo,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "pricing-product-title",
                                            children: item1.title
                                        }),
                                        !isMobile && activeItemIndex === index2 ? /*#__PURE__*/ _jsx("div", {
                                            className: "pricing-arrow-up"
                                        }) : null,
                                        isMobile ? ArrowUpDownIcon(activeItemIndex === index2) : null
                                    ]
                                }, "item-".concat(index2)),
                                isMobile && activeItemIndex === index2 ? /*#__PURE__*/ _jsx("ul", {
                                    className: "pricing-mobile-intro-box",
                                    children: intro.map(function(item, index) {
                                        /*#__PURE__*/ return _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs("a", {
                                                target: "_blank",
                                                href: item.link || DEFAULT_URL,
                                                children: [
                                                    /*#__PURE__*/ _jsxs("h4", {
                                                        children: [
                                                            item.title,
                                                            item.hasCalculator ? /*#__PURE__*/ _jsx("i", {
                                                                className: "svg-cal",
                                                                children: CalculatorIcon()
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: item.text
                                                    })
                                                ]
                                            })
                                        }, "intro-".concat(index));
                                    })
                                }, "ul-".concat(index2)) : null, 
                            ];
                        }),
                        !isMobile && arrayGenerator(5 - group.length, function(indx) {
                            /*#__PURE__*/ return _jsx("li", {
                                className: "pricing-empty-li"
                            }, "empty-".concat(group.length + indx));
                        })
                    ]
                }),
                !isMobile && showIntro ? /*#__PURE__*/ _jsx("div", {
                    className: "pricing-intro-box-wrapper",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "pricing-intro-box",
                        children: intro.map(function(item, index) {
                            /*#__PURE__*/ return _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    target: "_blank",
                                    href: item.link || DEFAULT_URL,
                                    children: [
                                        /*#__PURE__*/ _jsxs("h4", {
                                            children: [
                                                item.title,
                                                item.hasCalculator ? /*#__PURE__*/ _jsx("i", {
                                                    className: "svg-cal",
                                                    children: CalculatorIcon()
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: item.text
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                }) : null
            ]
        }, "group-".concat(row)));
    };
    return(/*#__PURE__*/ _jsx("section", _objectSpread({
        className: 'pricing-products-service-box',
        style: style
    }, reportShow([
        'show_productsService',
        index1,
        title
    ]), {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pricing-products-service-body",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "pricing-products-service-title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pricing-products-list",
                    children: arrayGenerator(rows, function(i) {
                        return buildGroup(i, list.slice(5 * i, 5 * i + 5));
                    })
                })
            ]
        })
    })));
};
